/**
 * Auth refresh policy for the Deputy WebSocket startup path.
 *
 * Public deployments authenticate the WebSocket with the existing HttpOnly
 * mrauth cookie. Localhost development keeps the old no-refresh path so local
 * Orchestrator loops do not require mrauth.
 *
 * @module deputy/authRefresh
 */

const LOCAL_AUTH_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);

export function shouldRefreshDeputyAuthCookie(hostname) {
    let resolvedHostname = hostname;
    if (resolvedHostname === undefined) {
        if (typeof window === 'undefined') return false;
        resolvedHostname = window.location.hostname;
    }
    if (!resolvedHostname) return false;
    return !LOCAL_AUTH_HOSTS.has(resolvedHostname);
}
